import { CharacterPack } from "./types";
import { lausannePack } from "./lausanne";
import { santaReindeerPack } from "./santa-reindeer";
import { fcLausanneSportPack } from "./fc-lausanne-sport";
import { georgiaFootballPack } from "./georgia-football";
import { swissIceHockeyPack } from "./swiss-ice-hockey";

export const characterPacks: CharacterPack[] = [
  //  lausannePack,
  //  fcLausanneSportPack,
  //  swissIceHockeyPack,
  //  georgiaFootballPack,
  santaReindeerPack,
];
